import { z } from 'zod'

import booleanSchema from './structured-data-validation/boolean-schema'
import dateSchema from './structured-data-validation/date-schema'
import enumSchema, { validateEnumSchema } from './structured-data-validation/enum-schema'
import { validateUniqueIds, validateUniqueLabels } from './structured-data-validation/helpers'
import multiselectSchema, { validateMultiselectSchema } from './structured-data-validation/multiselect-schema'
import numberSchema from './structured-data-validation/number-schema'
import stringSchema from './structured-data-validation/string-schema'

export const structuredDataSchemaItemValidation = z
  .discriminatedUnion('type', [stringSchema, numberSchema, booleanSchema, dateSchema, enumSchema, multiselectSchema])
  .refine(validateEnumSchema.fn, validateEnumSchema.error)
  .refine(validateMultiselectSchema.fn, validateMultiselectSchema.error)

export const structuredDataSchemaValidation = z
  .array(structuredDataSchemaItemValidation)
  .min(1, 'At least one field is required in each section')
  .refine(validateUniqueIds.fn, validateUniqueIds.error)
  .refine(validateUniqueLabels.fn, validateUniqueLabels.error)

export const structuredDataDisplayValidation = z
  .array(
    z.object({
      id: z.string(),
      label: z.string(),
      structuredDataIds: z.array(z.string()),
    }),
  )
  .refine(validateUniqueIds.fn, validateUniqueIds.error)
  .refine(validateUniqueLabels.fn, validateUniqueLabels.error)
